var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "header-component" } },
    [
      _c("mds-page-shell", {
        attrs: {
          logo: _vm.morningstarLogo,
          "logo-responsive": _vm.morningstarLogo,
          "logo-alt": "Morningstar Logo",
        },
        scopedSlots: _vm._u([
          {
            key: "mds-page-shell-masthead-right",
            fn: function () {
              return [
                _vm.$route.name === "Unauthorized" ||
                _vm.$route.name === "PaymentError"
                  ? _c(
                      "mds-button",
                      {
                        attrs: { variation: "secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.logoutClicked()
                          },
                        },
                      },
                      [_vm._v(" Logout ")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }